import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x-gray.svg'
import _imports_1 from '@/app/ui/assets/svg/plus-active.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-472173ac")

_pushScopeId("data-v-472173ac")
const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "w-10/12 space-y-6 pb-8 px-4" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-y-4 gap-x-6" }
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_5 = { class: "mt-6 px-3" }
const _hoisted_6 = { class: "flex flex-row gap-x-2 lp-checkbox p-field-checkbox" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { for: "checkbox-forward-commission-detail-shipment-label" }, "Shipment", -1)
const _hoisted_8 = { class: "grid grid-cols-4 gap-4 py-3 pl-8" }
const _hoisted_9 = { class: "flex flex-row gap-x-2 lp-checkbox p-field-checkbox py-3" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "checkbox-forward-commission-detail-shipment-label" }, "Retail", -1)
const _hoisted_11 = { class: "flex flex-row gap-x-2 lp-checkbox p-field-checkbox py-3" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { for: "checkbox-forward-commission-detail-shipment-label" }, "Client", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_14 = { class: "space-y-6" }
const _hoisted_15 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_16 = { class: "space-y-4" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "px-3 flex flex-wrap flex-row" }, [
  /*#__PURE__*/_createVNode("div", { class: "w-3/12 font-semibold text-12px xxl:text-14px" }, " Id "),
  /*#__PURE__*/_createVNode("div", { class: "w-4/12 font-semibold text-12px xxl:text-14px" }, " Batas Akhir Milestone "),
  /*#__PURE__*/_createVNode("div", { class: "w-4/12 font-semibold text-12px xxl:text-14px" }, " Tambahan Komisi ")
], -1)
const _hoisted_18 = { class: "px-3 w-full" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "border-t" }, null, -1)
const _hoisted_20 = { class: "w-3/12" }
const _hoisted_21 = { class: "w-10/12" }
const _hoisted_22 = { class: "w-4/12" }
const _hoisted_23 = { class: "w-10/12" }
const _hoisted_24 = { class: "w-4/12" }
const _hoisted_25 = { class: "w-10/12" }
const _hoisted_26 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "x"
}, null, -1)
const _hoisted_27 = { class: "flex flex-row justify-between py-4" }
const _hoisted_28 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "plus active"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Tambah Milestone ")
const _hoisted_30 = /*#__PURE__*/_createVNode("hr", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_select_search = _resolveComponent("select-search")!
  const _component_Title = _resolveComponent("Title")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    onBack: _ctx.goBack,
    title: _ctx.titlePage,
    loading: _ctx.loadingDetail,
    error: _ctx.errorDetail.isError,
    errorType: _ctx.errorDetail.errorType,
    onTryAgain: _ctx.fetchDetailCommissionProgressiveConfiguration,
    "full-page": "",
    "custom-class": "px-0",
    "vertical-separator": false,
    "leave-page-confirmation": _ctx.leavePageConfirmation,
    "onUpdate:leave-page-confirmation": _cache[9] || (_cache[9] = ($event: any) => (_ctx.leavePageConfirmation = $event)),
    onLeavePage: _ctx.onLeavePage
  }, {
    "top-right": _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_lp_button, {
          "text-color": "white",
          customClass: "w-full py-2.5",
          title: "Simpan",
          onClick: _ctx.onSaveForm,
          disabled: !_ctx.isFormValid
        }, null, 8, ["onClick", "disabled"])
      ])
    ]),
    data: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_DataWrapper, { label: "Tanggal Mulai" }, {
            default: _withId(() => [
              _createVNode(_component_DatePicker, _mergeProps({
                modelValue: _ctx.form.startDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.startDate = $event))
              }, _ctx.datePickerAttributes, {
                class: "my-2",
                disabled: !_ctx.isFormTypeAdd
              }), null, 16, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, { label: "Tanggal Berakhir" }, {
            default: _withId(() => [
              _createVNode(_component_DatePicker, _mergeProps({
                class: "my-2",
                modelValue: _ctx.form.endDate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.endDate = $event))
              }, _ctx.datePickerAttributes), null, 16, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, { label: "Berlaku Untuk" }, {
            default: _withId(() => [
              _createVNode(_component_select_search, {
                class: "my-2",
                "is-disabled": "",
                "model-value": "All POS"
              })
            ]),
            _: 1
          })
        ]),
        _hoisted_4,
        _createVNode(_component_DataWrapper, null, {
          default: _withId(() => [
            _createVNode(_component_Title, { label: "Digunakan Untuk" }),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_Checkbox, {
                  id: "checkbox-forward-commission-detail-shipment-label",
                  name: "commission-applied-to-label",
                  value: "shipment",
                  modelValue: _ctx.form.commissionAppliedTo,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.commissionAppliedTo = $event)),
                  onChange: _ctx.onChangeCommissionAppliedTo
                }, null, 8, ["modelValue", "onChange"]),
                _hoisted_7
              ]),
              _createVNode("div", _hoisted_8, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableShipmentPrefix, (option, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: option,
                    class: ["gap-x-2 flex flex-row lp-checkbox p-field-checkbox", `${index > 5 && index % 3 === 0 && 'col-span-2'}`]
                  }, [
                    _createVNode(_component_Checkbox, {
                      id: `checkbox-forward-commission-detail-${option}`,
                      name: "commission-applied-to",
                      value: option,
                      onChange: _ctx.onChangeCommissionShipmentPrefix,
                      modelValue: _ctx.form.commissionShipmentPrefix,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.commissionShipmentPrefix = $event))
                    }, null, 8, ["id", "value", "onChange", "modelValue"]),
                    _createVNode("label", {
                      for: `checkbox-forward-commission-detail-${option}`
                    }, _toDisplayString(option), 9, ["for"])
                  ], 2))
                }), 128))
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_Checkbox, {
                  id: "checkbox-forward-commission-detail-retail-label",
                  name: "commission-applied-to-label",
                  value: "retail",
                  modelValue: _ctx.form.commissionAppliedTo,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.commissionAppliedTo = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_10
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_Checkbox, {
                  id: "checkbox-forward-commission-detail-client-label",
                  name: "commission-applied-to-label",
                  value: "client",
                  modelValue: _ctx.form.commissionAppliedTo,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.commissionAppliedTo = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_12
              ])
            ])
          ]),
          _: 1
        }),
        _hoisted_13,
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_Title, { label: "Kalkulasi Perhitungan" }),
          _createVNode(_component_DataWrapper, {
            label: "Parameter Perhitungan",
            class: "px-3"
          }, {
            default: _withId(() => [
              _createVNode(_component_CustomDropdown, {
                options: _ctx.optionParameter,
                onSelect: _ctx.selectParameter,
                placeholder: "Pilih parameter perhitungan",
                isCustomWidth: "",
                selectedItem: _ctx.form.commissionParameter,
                class: "w-full mt-1.5"
              }, null, 8, ["options", "onSelect", "selectedItem"])
            ]),
            _: 1
          })
        ]),
        _hoisted_15,
        _createVNode("div", _hoisted_16, [
          _createVNode(_component_Title, { label: "Perhitungan Tier" }),
          _hoisted_17,
          _createVNode("div", _hoisted_18, [
            _hoisted_19,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.milestones, (config, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: "flex flex-wrap flex-row items-start py-6 border-b border-dashed"
              }, [
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _createVNode(_component_lp_input, {
                      disabled: "",
                      "model-value": index + 1
                    }, null, 8, ["model-value"])
                  ])
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, [
                    _createVNode(_component_lp_input, _mergeProps({ "error-icon": false }, _ctx.isErrorMilestone(index), {
                      modelValue: config.milestone,
                      "onUpdate:modelValue": ($event: any) => (config.milestone = $event),
                      format: _ctx.formatMilestone,
                      prefix: "IDR"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "format"])
                  ])
                ]),
                _createVNode("div", _hoisted_24, [
                  _createVNode("div", _hoisted_25, [
                    _createVNode(_component_lp_input, {
                      "error-icon": false,
                      error: _ctx.isErrorCommission(index),
                      format: _ctx.formatCommission,
                      modelValue: config.commission,
                      "onUpdate:modelValue": ($event: any) => (config.commission = $event),
                      prefix: "%"
                    }, null, 8, ["error", "format", "modelValue", "onUpdate:modelValue"])
                  ])
                ]),
                _withDirectives(_createVNode("div", {
                  onClick: ($event: any) => (_ctx.removeMilestones(index)),
                  class: "self-center cursor-pointer ml-3 relative"
                }, [
                  _hoisted_26
                ], 8, ["onClick"]), [
                  [_vShow, _ctx.ableToRemoveMilestones]
                ])
              ]))
            }), 128)),
            _withDirectives(_createVNode("div", _hoisted_27, [
              _createVNode("div", {
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addMilestones && _ctx.addMilestones(...args))),
                class: "cursor-pointer flex gap-3 text-red-lp-300"
              }, [
                _hoisted_28,
                _hoisted_29
              ])
            ], 512), [
              [_vShow, _ctx.ableToAddMilestones]
            ])
          ])
        ]),
        _hoisted_30,
        _createVNode(_component_DataWrapper, { label: "Syarat & Ketentuan" }, {
          default: _withId(() => [
            _createVNode(_component_lp_input, {
              modelValue: _ctx.form.termsAndConditions,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.termsAndConditions = $event)),
              maxLength: 2000,
              showMaxLength: "",
              textAreaRows: "10",
              type: "textarea",
              placeholder: "Tulis syarat & ketentuan"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain", "leave-page-confirmation", "onLeavePage"]))
})